var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function toTimePointsByYearMap(timePoints) {
    return timePoints.reduce(function (years, tp) {
        var _a;
        if (!years.hasOwnProperty(tp.year)) {
            years[tp.year] = [];
        }
        (_a = years[tp.year]) === null || _a === void 0 ? void 0 : _a.push(__assign({}, tp));
        return years;
    }, {});
}
